import { createContext, FC, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { NotificationType } from './constants';

export interface INotificationContext {
  navigateNotificationItem: (item: any) => void;
}

const defaultValue = {
  navigateNotificationItem: () => {},
};

const NotificationContext = createContext<INotificationContext>(defaultValue);

export const NotificationProvider: FC = ({ children }) => {
  const history = useHistory();

  const navigateNotificationItem = (notification: any) => {
    let notificationType = notification.type || '';

    switch (notificationType) {
      case '':
        return;
      case NotificationType.AsyncData: // no need to redirect this type as a requirement
        return;
      default:
        // const addCharParam = notification.webUrl.search(/\?/) >= 0 ? '&' : '?';
        // history.push('/' + notification.webUrl + addCharParam + 'notiCode=' + notification.id); //Error notification
        const addCharParam = '';
        history.push('/' + notification.webUrl + addCharParam); //Error notification
    }
  };

  const contextValue = {
    navigateNotificationItem: navigateNotificationItem,
  };

  return (
    <NotificationContext.Provider value={contextValue}>{children}</NotificationContext.Provider>
  );
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
